import { escapeHtml as esc, printHtml } from '../../utils/invoice'
import { brandColors } from '../../data/brandColors'
import { hoursLabel, type StaffHoursMonth } from '../../core/rules/staffHours'
import { dayShort } from '../../core/format/dates'

/** Het urenoverzicht als printbaar document, om naast de factuur van de collega te leggen. */
export function staffHoursHtml(m: StaffHoursMonth, name: string, monthLabel: string, salonName: string): string {
  const rows = m.days
    .map(
      (d) =>
        `<tr><td>${esc(dayShort(d.date))}${d.exception ? ' *' : ''}</td><td>${esc(d.open)}–${esc(d.close)}</td><td class="r">${esc(hoursLabel(d.minutes))}</td><td class="r">${d.done}</td><td class="r">${d.noShow}</td><td class="r">${d.cancelled}</td></tr>`,
    )
    .join('')
  return `<!doctype html><html lang="nl"><head><meta charset="utf-8"><title>Uren ${esc(name)} ${esc(monthLabel)}</title><style>
body{font-family:system-ui,sans-serif;color:${brandColors.ink};margin:40px;font-size:13px}
h1{font-size:20px;font-weight:500;margin:0 0 4px}
.muted{color:#6b6460}
table{width:100%;border-collapse:collapse;margin-top:20px}
th,td{padding:6px 4px;border-bottom:1px solid #e7e1da;text-align:left}
th{font-weight:500}
.r{text-align:right}
tfoot td{font-weight:600;border-bottom:none}
</style></head><body>
<strong>${esc(salonName)}</strong>
<h1 style="margin-top:20px">Urenoverzicht ${esc(name)}</h1>
<div class="muted">${esc(monthLabel)}</div>
<table><thead><tr><th>Dag</th><th>Tijden</th><th class="r">Uren</th><th class="r">Afgerond</th><th class="r">Niet gekomen</th><th class="r">Geannuleerd</th></tr></thead>
<tbody>${rows || '<tr><td colspan="6" class="muted">Geen gewerkte dagen.</td></tr>'}</tbody>
<tfoot><tr><td>Totaal · ${m.totals.days} ${m.totals.days === 1 ? 'dag' : 'dagen'}</td><td></td><td class="r">${esc(hoursLabel(m.totals.minutes))}</td><td class="r">${m.totals.done}</td><td class="r">${m.totals.noShow}</td><td class="r">${m.totals.cancelled}</td></tr></tfoot>
</table>
${m.days.some((d) => d.exception) ? '<p class="muted" style="margin-top:12px">* Afwijkende dag (ruil, extra dag of niet als salondag ingevoerd).</p>' : ''}
</body></html>`
}

export const printStaffHours = (m: StaffHoursMonth, name: string, monthLabel: string, salonName: string) =>
  printHtml(staffHoursHtml(m, name, monthLabel, salonName), `uren-${name.toLowerCase()}-${m.month}.html`, 'Urenoverzicht')
